import {
	mapState
} from 'vuex';

export const common = {
	data() {
		return {
			themeColor: '#52C4C9',
			levelListCommon:[
				{name:'小一',value:'s1'},
				{name:'小二',value:'s2'},
				{name:'小三',value:'s3'},
				{name:'小四',value:'s4'},
				{name:'小五',value:'s5'},
				{name:'小六',value:'s6'},
				{name:'中一',value:'m1'},
				{name:'中二',value:'m2'},
				{name:'中三',value:'m3'},
				{name:'中四',value:'m4'},
				{name:'中五',value:'m5'},
				{name:'中六',value:'m6'},
				{name:'y1',value:'y1'},
				{name:'y2',value:'y2'},
				{name:'y3',value:'y3'},
				{name:'y4',value:'y4'},
				{name:'y5',value:'y5'},
				{name:'y6',value:'y6'},
				{name:'y7',value:'y7'},
				{name:'y8',value:'y8'},
				{name:'y9',value:'y9'},
				{name:'y10',value:'y10'},
				{name:'y11',value:'y11'},
				{name:'y12',value:'y12'},
			]
		}
	},
	computed: {
		...mapState({
			test: state => state.test.test
		}),
		getSelectKey() {
			return this.$route.name;
		}
	},
	methods: {
		changeSToN(arr){
			let group_id = [];
			arr.forEach((item) => {
				let a = Number(item);
				group_id.push(a);
			});
			return group_id
		},
		openKefu(id) {
			console.log("用户id",id)
			FastIm.showWindow('fastim',id)
		},
		refreshPage(page) { // 比如弹出层操作后要跳转到某个页面就这样执行
			this.$router.push({
				path: '/refresh',
				query: {
					path: page
				}
			});
		},
		checkLogin() {
			// 判断是否登录
			if (localStorage.getItem('account-token')) {
				return true
			}
			return false
		},
		changeNum(num) {
			if (num == 1) {
				return '一'
			} else if (num == 2) {
				return '二'
			} else if (num == 3) {
				return '三'
			} else if (num == 4) {
				return '四'
			} else if (num == 5) {
				return '五'
			} else if (num == 6) {
				return '六'
			} else if (num == 7) {
				return '日'
			}
		},
		getCurrency() {
			return localStorage.getItem('currency')
		},
		setUserInfo() {
			if (this.checkLogin()) {
				this.$http.api('user/index').then(res => {
					this.updateUserInfo(res.info)
					localStorage.setItem('timeZone', res.info.time_zone.name)
				})
			}

		},
		setTeacherInfo() {
			if (this.checkLogin() && this.userInfo && this.userInfo.teacher_id) {
				this.$http.api('teacher/teacher/info').then(res => {
					this.updateTeacherInfo(res.info)
				})
			}

		},
		// 根据人民币金额和汇率计算目标货币金额
		convertCurrency(rmbAmount) {
			rmbAmount = Number(rmbAmount)
			let exchangeRate = Number(localStorage.getItem('rate'))
			if (typeof rmbAmount !== 'number' || typeof exchangeRate !== 'number') {
				throw new Error('输入的金额和汇率必须为数字');
			}
			return (rmbAmount * exchangeRate).toFixed(2);
		},
		async informationIntegration(type) {
			try {
				const res = await this.$http.api('information/informationIntegration', {
					type: type
				});
				return res;
			} catch (error) {
				console.error('信息集成请求出错:', error);
				throw error;
			}
		},
		// 获取当天日期
		getTodayDate() {
			const today = new Date();
			const year = today.getFullYear();
			const month = String(today.getMonth() + 1).padStart(2, '0'); // 自动补零
			const day = String(today.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},
		convertToTimeZone(beijingTimeStr) {
			let timeZone = localStorage.getItem('timeZone')
			// console.log("原来的",beijingTimeStr,timeZone);
		    // 创建北京时间的Date对象
		    const beijingTime = new Date(beijingTimeStr);
		
		    // 检查输入是否有效
		    if (isNaN(beijingTime.getTime())) {
		        throw new Error('Invalid date format. Please use "YYYY-MM-DD HH:mm:ss"');
		    }
		
		    // 转换为指定美国时区时间
		    const usTime = new Date(beijingTime.toLocaleString('en-US', {
		        timeZone: timeZone
		    }));
		
		    // 获取各部分值
		    let weekday = usTime.getDay(); // 0-6 (0是周日)
		    weekday = weekday === 0 ? 7 : weekday; // 转换为1-7 (周一是1，周日是7)
		    const year = usTime.getFullYear();
		    const month = usTime.getMonth() + 1; // 0-11 → 1-12
		    const day = usTime.getDate();
		    const hour = usTime.getHours();
		    const minute = usTime.getMinutes();
		
		    // 格式化时间字符串
		    const timeInTargetZone = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} ${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:00`;
			
			let obj = {
				formattedTime: timeInTargetZone,
				date: {
				    weekday: weekday,
				    year: year,
				    month: month<10?'0'+month:month,
				    day: day<10?'0'+day:day,
				    hour: hour<10?'0'+hour:hour,
				    minute: minute<10?'0'+minute:minute
				}
			}
			// console.log("----------",obj);
		    return {
		        formattedTime: timeInTargetZone,
		        date: {
		            week: weekday,
		            year: year,
		            month: month<10?'0'+month:month,
		            day: day<10?'0'+day:day,
		            hour: hour<10?'0'+hour:hour,
		            minute: minute<10?'0'+minute:minute
		        }
		    };
		},
		// 时区转换
		// convertToTimeZone(beijingTime) {
		// 	let timeZone = localStorage.getItem('timeZone');
		// 	// 解析输入的北京时间
		// 	let date = new Date(beijingTime);

		// 	// 设置格式化选项
		// 	let options = {
		// 		timeZone: timeZone,
		// 		hour12: false, // 24小时制
		// 		year: 'numeric',
		// 		month: '2-digit',
		// 		day: '2-digit',
		// 		hour: '2-digit',
		// 		minute: '2-digit',
		// 		second: '2-digit',
		// 		// weekday: 'long', // 获取星期几
		// 	};

		// 	// 使用 Intl.DateTimeFormat 转换时区时间
		// 	let formatter = new Intl.DateTimeFormat('en-US', options); // 使用 'en-US' 避免非标准时区问题
		// 	let timeInTargetZone = formatter.format(date);

		// 	// 获取在目标时区的年月日和周几
		// 	let dateOptions = {
		// 		timeZone: timeZone,
		// 		hour12: false, // 24小时制
		// 		year: 'numeric',
		// 		month: '2-digit',
		// 		day: '2-digit',
		// 		hour: '2-digit',
		// 		minute: '2-digit',
		// 		second: '2-digit',
		// 		// weekday: 'long',
		// 	};

		// 	// 格式化年月日和星期
		// 	let formatterDate = new Intl.DateTimeFormat('en-US', dateOptions);
		// 	let dateInTargetZone = formatterDate.format(date);

		// 	// 拆分 dateInTargetZone，提取年月日和星期几
		// 	const parts = formatter.formatToParts(date);

		// 	// 提取年、月、日、小时、分钟、星期几
		// 	let year, month, day, hour, minute, weekday;
		// 	parts.forEach(part => {
		// 		if (part.type === 'year') year = part.value;
		// 		if (part.type === 'month') month = part.value;
		// 		if (part.type === 'day') day = part.value;
		// 		if (part.type === 'hour') hour = part.value;
		// 		if (part.type === 'minute') minute = part.value;
		// 		if (part.type === 'weekday') weekday = part.value;
		// 	});

		// 	let obj = {
		// 		formattedTime: timeInTargetZone,
		// 		date: {
		// 			weekday: weekday, // 星期几
		// 			year: year, // 年
		// 			month: month, // 月
		// 			day: day, // 日
		// 			hour: hour, // 小时
		// 			minute: minute, // 分钟
		// 		}
		// 	};

		// 	console.log("---------转化时间", obj);
		// 	// 返回一个对象，拆分后的年月日周几
		// 	return obj;
		// }

	}
}